import React from 'react';
import './About.css'

const About = () => {
    return (
        <div className="us">
            <div className="head">
                <h2>About Us</h2>
            </div>
            <div className="about">
                <h5>
                   You can learn photography by us and its our training center . David is known for his quick turnaround, friendly, yet professional manner and quality imagery.  He has also had plenty of experience working with VIPs,  high profile individuals and brands; able to work with them in a respectful and unobtrusive reportage photography style.
                    While David focuses on event photography, he works closely with a small selection of trusted videographers, so if your event also needs to be documented through video in addition to photography, this is also something he can manage for your event.
                    We learning you all of possible photography tips and you will become a good photographer. Well trusted and experienced Corporate Event Photographer, creating engaging documentary imagery for client’s events and conferences . David is known for his quick turnaround, friendly, yet professional manner and quality imagery.  He has also had plenty of experience working with VIPs,  high profile individuals and brands; able to work with them in a respectful and unobtrusive reportage photography style.
                    While David focuses on event photography, he works closely with a small selection of trusted videographers, so if your event also needs to be documented through video in addition to photography, this is also something he can manage for your event.
                    We learning you all of possible photography tips and you will become a good photographer.
                </h5>
            </div>
        </div>
    );
};

export default About;